import { useContext, useMemo } from "react";
import SwaggerContext from "../SwaggerContext";
import { createGameSessionService, createUserAnswerService } from "behaviour-analyzer-shared";
import { createGameSessionApiAdapter } from "../adapters/gameSessionApiAdapter";
import { createUserAnswerApiAdapter } from "../adapters/userAnswerApiAdapter";

export function useGameServices() {
  const { gameSessionApi } = useContext(SwaggerContext);

  return useMemo(() => ({
    gameSessionService: createGameSessionService(createGameSessionApiAdapter(gameSessionApi)),
    userAnswerService: createUserAnswerService(createUserAnswerApiAdapter(gameSessionApi)),
  }), [gameSessionApi]);
}
